import type { Dictionary, Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { DateTime } from 'luxon';

@Entity()
export class CampusNotificationFilter extends AdornisFilter {
  static override _class = 'CampusNotificationFilter';

  constructor(doc: Partial<EntityData<CampusNotificationFilter>>) {
    super(doc);
  }

  @Field(type => Boolean, { default: v => v ?? false })
  public noTimeLimit: Maybe<boolean>;

  @Field(type => DateTime)
  public pastTo: Maybe<DateTime>;

  @Field(type => String)
  public userID: Maybe<string>;

  @Field(type => Boolean, { default: v => v ?? false })
  public forEmployees: Maybe<boolean>;

  @Field(type => [Int], { default: v => v ?? [] })
  public forGrades: Maybe<number[]>;

  @Field(type => [ID], { default: v => v ?? [] })
  public forGroupIDs: Maybe<string[]>;

  @Field(type => [ID], { default: v => v ?? [] })
  public forSchoolIDs: Maybe<string[]>;

  @Field(type => Boolean, { default: v => v ?? false })
  public onlyOwnSchool: Maybe<boolean>;

  override getMongoFilter() {
    const obj = this.toObject();
    const selector: Dictionary<any> = {};
    selector.$and = [];

    const orArrayEmployee: any[] = [];
    orArrayEmployee.push({ forEmployees: null });
    if (obj.forEmployees === true) {
      orArrayEmployee.push({ forEmployees: true });
    } else if (obj.forEmployees === false) {
      orArrayEmployee.push({ forEmployees: false });
    }
    selector.$and.push({ $or: orArrayEmployee });

    if (obj.forGrades?.length) {
      const orArrayGrades: any[] = [];
      orArrayGrades.push({ forGrades: null });
      orArrayGrades.push({ forGrades: { $size: 0 } });
      orArrayGrades.push({ forGrades: { $in: obj.forGrades } });
      selector.$and.push({ $or: orArrayGrades });
    }

    if (obj.forGroupIDs?.length) {
      const orArrayGroups: any[] = [];
      orArrayGroups.push({ forGroupIDs: null });
      orArrayGroups.push({ forGroupIDs: { $size: 0 } });
      orArrayGroups.push({ forGroupIDs: { $in: obj.forGroupIDs } });
      selector.$and.push({ $or: orArrayGroups });
    }

    if (obj.forSchoolIDs?.length) {
      const orArraySchools: any[] = [];
      orArraySchools.push({ forSchoolIDs: null });
      orArraySchools.push({ forSchoolIDs: { $size: 0 } });
      orArraySchools.push({ forSchoolIDs: { $in: obj.forSchoolIDs } });
      selector.$and.push({ $or: orArraySchools });
    }

    if (obj.pastTo) {
      selector.$and.push({ createdAt: { $gte: DateTime.fromJSDate(obj.pastTo).startOf('day').toJSDate() } });
    }

    if (obj.onlyOwnSchool) {
      selector.$and.push({
        forSchoolIDs: { $in: obj.forSchoolIDs },
      });
    }

    return selector;
  }
}
